import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlus,
    faEdit,
    faTrash,
    faTimes,
    faCheckCircle
} from "@fortawesome/free-solid-svg-icons";

import Breadcrumb from "../../components/Ui_Element/Breadcrumb";
import DotLoader from "../../components/Ui_Element/DotLoader";
import { post, getlist, deleteitem, put } from "../../contexts/apicontexts";
import config from "../../config";
import { showToast } from "../../components/Ui_Element/CustomToast";

export default function Roles() {
    const [roles, setRoles] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isLoder, setIsLoder] = useState(false);
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({
        id: "",
        name: "",
        isSystem: false
    });

    const fetchRoles = async () => {
        setIsLoder(true);
        const res = await getlist(`${config.baseurl}Roles/getlist`);
        if (res?.status === 200) {
            setRoles(res.data || []);
        }
        setIsLoder(false);
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    const openAddModal = () => {
        setForm({ id: "", name: "", isSystem: false });
        setErrors({});
        setIsOpen(true);
    };

    const openEditModal = (role) => {
        setForm(role);
        setErrors({});
        setIsOpen(true);
    };

    const closeModal = () => setIsOpen(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({
            ...form,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const validate = () => {
        let err = {};
        if (!form.name.trim()) err.name = "Role name is required";
        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        setIsLoder(true);

        const res = form.id
            ? await put(`${config.baseurl}Roles/update`, form)
            : await post(`${config.baseurl}Roles/add`, form);

        if (res?.status === 200) {
            showToast.success(form.id ? "Role updated" : "Role added");
            closeModal();
            fetchRoles();
        }

        setIsLoder(false);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this role?")) return;

        setIsLoder(true);
        const res = await deleteitem(`${config.baseurl}Roles/${id}`);
        if (res?.status === 200) {
            showToast("success", "Role deleted");
            fetchRoles();
        }
        setIsLoder(false);
    };

    return (
        <div className="p-4 md:p-6 min-h-screen bg-gray-50 dark:bg-gray-900">
            <Breadcrumb pageName="Roles" currentPage="Roles" />

            <div className="mt-4 bg-white dark:bg-gray-800 rounded-xl shadow border dark:border-gray-700 overflow-hidden">

                {/* HEADER */}
                <div className="flex justify-between items-center px-5 py-3 border-b dark:border-gray-700
                    bg-gradient-to-r from-[#C04C2A] to-[#4A1B13]">

                    <div className="flex items-center gap-3">
                        <h2 className="text-xl font-bold text-white">
                            Role List
                        </h2>
                        {isLoder && <DotLoader color="#fff" />}
                    </div>

                    <button
                        onClick={openAddModal}
                        className="w-10 h-10 rounded-full bg-white dark:bg-gray-200 text-[#C04C2A] shadow"
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                </div>

                {/* TABLE */}
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200">
                            <tr>
                                <th className="p-3 text-left">Name</th>
                                <th className="p-3 text-center">System</th>
                                <th className="p-3 text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-800 dark:text-gray-300">
                            {roles.length === 0 && (
                                <tr>
                                    <td colSpan="3" className="text-center p-4">
                                        No roles found
                                    </td>
                                </tr>
                            )}

                            {roles.map((r) => (
                                <tr
                                    key={r.id}
                                    className="border-t dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/40"
                                >
                                    <td className="p-3">{r.name}</td>
                                    <td className="p-3 text-center">
                                        {r.isSystem && (
                                            <FontAwesomeIcon
                                                icon={faCheckCircle}
                                                className="text-green-600"
                                            />
                                        )}
                                    </td>
                                    <td className="p-3 text-center space-x-3">
                                        <button
                                            onClick={() => openEditModal(r)}
                                            className="text-blue-600 dark:text-blue-400"
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>

                                        {/* {!r.isSystem && (
                                            <button
                                                onClick={() => handleDelete(r.id)}
                                                className="text-red-600 dark:text-red-400"
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        )} */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* MODAL */}
            {isOpen && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="w-full max-w-md p-5 rounded-xl bg-white dark:bg-gray-800 border dark:border-gray-700">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                                {form.id ? "Edit Role" : "Add Role"}
                            </h3>
                            <button
                                onClick={closeModal}
                                className="text-gray-500 dark:text-gray-300"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <div className="space-y-4">
                            <div>
                                <label className="text-sm text-gray-600 dark:text-gray-300">
                                    Role Name
                                </label>
                                <input
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 rounded border
                                        bg-white dark:bg-gray-700
                                        text-gray-800 dark:text-gray-200
                                        border-gray-300 dark:border-gray-600"
                                />
                                {errors.name && (
                                    <p className="text-red-500 text-xs mt-1">
                                        {errors.name}
                                    </p>
                                )}
                            </div>

                            <label className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                                <input
                                    type="checkbox"
                                    name="isSystem"
                                    checked={form.isSystem}
                                    onChange={handleChange}
                                />
                                System Role
                            </label>

                            <button
                                onClick={handleSubmit}
                                className="w-full py-2 rounded text-white
                                    bg-[#C04C2A] hover:bg-[#a83f22]"
                            >
                                {form.id ? "Update" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
